import {Button, Stack, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

export const NoMoreStoppages: React.FC<{onClose: () => void}> = ({onClose}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Stack
      height="100%"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      data-test-id="thank-you-message"
    >
      <Typography variant="h3">{t('newStoppagesBanner.thankYou')}</Typography>
      <Typography>{t('newStoppagesBanner.noMoreStoppagesAtThisTime')}</Typography>
      <div>
        <Button variant="text" onClick={onClose}>
          {t('button.close')}
        </Button>
      </div>
    </Stack>
  )
}
